var _excluded = ["at", "bt", "tt"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @file 发送停留时长上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/stay
 */
import request from './util/request';
import configurable from './util/configurable';
import performance from './util/performance';
import { on, off } from './util/dom';
import { trackID, getUserID, Config, getRouteChangeEventIsWrapped, setRouteChangeEventWrapped, RenderType, documentHidden, documentVisibilityChange } from './util/config';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';
var win = typeof window !== 'undefined' && window;
var doc = win && document; // 进入页面时间戳

var start = performance.timing && performance.timing.responseEnd || +new Date(); // 跳出时间

var bounceTimes = 0; // 活动时间

var activeTime = 0; // 最后活动时间

var lastActiveTime = start; // 停留时长统计

var changeCount = function changeCount() {
  var now = +new Date();

  if (doc[documentHidden]) {
    if (bounceTimes) {
      activeTime += now - lastActiveTime;
    } else {
      activeTime = now - start;
    }

    bounceTimes++;
  } else {
    lastActiveTime = now;
  }
};

on(doc, documentVisibilityChange, changeCount);
/**
 * 获取页面路径部分
 *
 * @function getPath
 * @return {string}
 */

var getPath = function getPath() {
  return location.pathname;
};
/**
 * 时长上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */


var report = configurable(function (json, callback) {
  var now = +new Date(); // 三个重要指标，避免覆盖真实统计值（作弊）

  /* eslint-disable no-unused-vars */

  var at = json.at,
      bt = json.bt,
      tt = json.tt,
      rest = _objectWithoutProperties(json, _excluded);
  /* eslint-enable no-unused-vars */
  // 要上报的数据


  var stayData = _objectSpread({
    // 当前页面 URL
    url: location.href,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: trackID,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: getUserID(),
    // 页面路径归类
    path: getPath(),
    // Active Time 活动时长
    at: activeTime + (now - lastActiveTime),
    // Bounce Times 切换次数
    bt: bounceTimes,
    // Total Time 总停留时长
    tt: now - start
  }, rest); // 上报后重置相关统计


  activeTime = 0;
  bounceTimes = 0;
  start = lastActiveTime = now;
  warnForbiddenKeys(stayData); // 为保证上报成功和简化逻辑，只支持 POST 方式的上报

  request('post', true)("".concat(Config.STAY), stayData, callback); // 自动上报点击指标数据到轻舟

  metric(_objectSpread(_objectSpread({}, stayData), {}, {
    metric: 'stay'
  }));
}, {});

function observe() {
  report({});
}
/**
 * 解除相关事件的绑定
 */


function destroy() {
  off(doc, documentVisibilityChange, changeCount);
  off(win, 'pushstate', observe);
  off(win, 'replacestate', observe);
  off(win, 'popstate', observe);
  off(win, 'hashchange', observe);
  off(win, 'beforeunload', observe);
  off(win, 'unload', destroy);
}

report.init = function (renderType) {
  if (renderType === RenderType.HISTORY) {
    if (!getRouteChangeEventIsWrapped()) {
      var wrap = function wrap(type) {
        var origin = history[type];
        setRouteChangeEventWrapped();
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var returnValue = origin.apply(history, args);
          var event = doc.createEvent('Event');
          event.initEvent(type.toLowerCase(), true, true);
          event.arguments = args;
          win.dispatchEvent(event);
          return returnValue;
        };
      };

      history.pushState = wrap('pushState');
      history.replaceState = wrap('replaceState');
    }

    on(win, 'pushstate', observe);
    on(win, 'replacestate', observe);
    on(win, 'popstate', observe);
  } else if (renderType === RenderType.HASH) {
    getPath = function getPath() {
      return location.hash.slice(1);
    };

    on(win, 'hashchange', observe);
  }
};

on(win, 'beforeunload', observe);
on(win, 'unload', destroy);
export default report;